import React, { Component } from 'react';
import C from "../config/Constants.js";
import { ReactComponent as LeftArrowSVG } from '../assets/leftarrow.svg';
import { ReactComponent as RightArrowSVG } from '../assets/rightarrow.svg';

class CategoryButtons extends Component {
    render () {
        var { video, onClickAmbi, onClickFD, onClickLeft, onClickRight, showPhases, index } = this.props

        // var progress = index % C.NUM_VIDS_PER_PHASE * 100 / C.NUM_VIDS_PER_PHASE
        var ambiStyle = {
            opacity: `${video?.phase === C.AMBIANCE_PHASE ? 1 : 0.2}`, 
            // borderImage: `${'linear-gradient(to right, #ffffff ' + progress + '%, transparent ' + (1 - progress) + '%) 100% 1'}`,
        }
        var fdStyle = {opacity: `${video?.phase === C.FOOD_DRINK_PHASE ? 1 : 0.2}`}
        return <div>
                {showPhases && <div className="CategoryButtons">
                    <button style={ambiStyle} onClick={onClickAmbi}>Ambiance</button>
                    <button style={fdStyle} onClick={onClickFD}>Food & Drinks</button>
                </div>}
            <br />
                <div className="LeftRightButtons">
                    <button onClick={onClickLeft}>{<LeftArrowSVG/>}</button>
                    <button onClick={onClickRight}>{<RightArrowSVG/>}</button>

                </div>
        </div>
    }
}

export default CategoryButtons;